export type Listener<T> = (value: T) => void;

/** Minimal typed event emitter. Returns an unsubscribe function from on(). */
export class TypedEvent<T> {
  private readonly listeners = new Set<Listener<T>>();

  on(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(value: T): void {
    for (const listener of [...this.listeners]) {
      listener(value);
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
